<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="TITLE">Faith Seeking Understanding</p>
<p class="SUBTITLE">An Introduction to Christian Theology</p>
<p class="EDITION"><span class="char-style-override-2">•</span> <span class="char-style-override-2">•</span><br/>Third Edition</p>
<p class="AUTHOR">Daniel L. Migliore</p>
<p class="COMPANY">William B. Eerdmans Publishing Company<br/>Grand Rapids, Michigan / Cambridge, U.K.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Migliore_Faith_Seeking_Understanding_text.vue?6afcafd9